import React, { useState ,useEffect} from "react";
import { ArrowRight, ArrowLeft, Search, ImagePlus, Plus } from "lucide-react";
import UploadImage from "../../assets/icons/squareCard/imageupload.png";
import MemberCard from './membercard'
import PlanCard from "./plancard";
import BiblePlan from "./bibleplan";
import { useDispatch, useSelector } from "react-redux";
import { readGalleryRequest } from "../../store/Gallery/galleryAction";
import { AiOutlineClose } from "react-icons/ai";
import { myCircleListAction } from "../../store/Users/UsersAction";
import  {getBibleSearchAction} from "../../store/Bible/BibleAction"
import { savePlanAction, saveDayPlanAction } from "../../store/planChurch/action";
import { readPlanAction } from "../../store/planChurch/action";
import { toast } from "react-toastify";
import ChristmasImage from "../../assets/images/christmas.jpg";
import Cropper from "react-easy-crop";
import JournalsPlan from "./journalsplan"
import VideosPlan from "./videoplan"
import DevotionCard from "./devotionCard"
import { useRef } from "react";
import {getJournalsAction} from "../../store/Bible/BibleAction"
import {readVideoAction} from "../../store/Home/HomeAction"
import { curriculumReadAction } from "../../store/Curriculum/CurriculumAction";
import CurriculumPlan from "./curriculumPlan"
import { IoClose } from "react-icons/io5";
import { saveGroup,saveDevotional,updateGroup } from "./operation";
import DevotionalPlan from "./devotionalPlan"; // Add this import
import {uploadAssestsAction} from "../../store/Home/HomeAction"
import {

  testimonialReadAction,
} from "../../store/Testimonial/TestimonialAction";
import {savePlanRequest,saveDayPlanRequest,saveDayPlanDetailRequest} from "../../store/Plan/planActions"
import TestimonialPlan from "./testimonialPlan"
import { availableUsersAction } from "../../store/Users/UsersAction";
import { saveYoutubePlanAction } from "../../store/Group/action";

const MENU_ITEMS = [
  { id: "members", label: "Add Group Members" },
  { id: "bible", label: "Create Bible Study from sermon" },
  { id: "plan", label: "Bible Plan" },
  { id: "devotionals", label: "Devotionals" },
  { id: "journals", label: "Journals" },
  { id: "videos", label: "Videos (TWG videos/Youtube links)" },
  { id: "curriculum", label: "Curriculums" },
  { id: "testimonial", label: "Testimonies" },

];


const CreateGroup = ({ onBack,editData,church }) => {
      const [activeMenu, setActiveMenu] = useState("members");
  const [showPlanBuilder, setShowPlanBuilder] = useState(false);
  const isEditMode = Boolean(editData?._id);
  const galleryList = useSelector((state) => state.gallery?.galleryList);
  const [showGalleryModal, setShowGalleryModal] = useState(false);
  const [selectedGalleryImage, setSelectedGalleryImage] = useState(null);
  // const [plans] = useState(INITIAL_PLANS);
  const [isCreatingPlan, setIsCreatingPlan] = useState(false);

  const [searchTxt, setSearchTxt] = useState("");
const [searchResults, setSearchResults] = useState([]);
const [isSearching, setIsSearching] = useState(false);
const { versionDetails } = useSelector((state) => state.bible);
const [activePlanIndex, setActivePlanIndex] = useState(null);
const [newVerseActive, setNewVerseActive] = useState(false);
const [planName, setPlanName] = useState("");
const [planDescription, setPlanDescription] = useState("");
const [allPlans,setAllPlans]=useState([]);
const [selectedBiblePlans, setSelectedBiblePlans] = useState([]);
const [selectedMembers, setSelectedMembers] = useState([]);
const [selectedJournals, setSelectedJournals] = useState([]);
const [selectedVideos, setSelectedVideos] = useState([]);
const fileInputRef = useRef(null);
const [CurriculumData,setCurriculumData]=useState([]);
const [imageSrc, setImageSrc] = useState(null);
const [croppedImage, setCroppedImage] = useState(null);
const [journals, setJournals] = useState([]);
const [videos, setVideos] = useState([]);
const [showRightPanel, setShowRightPanel] = useState(true);
const [crop, setCrop] = useState({ x: 0, y: 0 });
const [zoom, setZoom] = useState(1);
const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
const [showCropper, setShowCropper] = useState(false);
const [groupName, setGroupName] = useState("");
const [groupImageUrl, setGroupImageUrl] = useState(null);

// Devotional image upload & crop
const devotionalFileInputRef = useRef(null);
const [devotionalImageSrc, setDevotionalImageSrc] = useState(null);
const [devotionalCroppedImage, setDevotionalCroppedImage] = useState(null);
const [savedDevotionals, setSavedDevotionals] = useState([]);
const [savedCurriculum,setsavedCurriculum]=useState([]);

const [devotionalTitle, setDevotionalTitle] = useState("");
const [showDevotionalForm, setShowDevotionalForm] = useState(false);
const [devotionalCrop, setDevotionalCrop] = useState({ x: 0, y: 0 });
const [devotionalZoom, setDevotionalZoom] = useState(1);
const [devotionalCroppedPixels, setDevotionalCroppedPixels] = useState(null);
const [showDevotionalCropper, setShowDevotionalCropper] = useState(false);
const [AllTestimonials, setAllTestimonials] = useState([]);
const [SavedTestimonials, setSavedTestimonials] = useState([]);
// Add these state variables near your other state declarations
const groupFileInputRef = useRef(null);
const [groupImageSrc, setGroupImageSrc] = useState(null);
const [groupCroppedImage, setGroupCroppedImage] = useState(null);
const [groupCrop, setGroupCrop] = useState({ x: 0, y: 0 });
const [groupZoom, setGroupZoom] = useState(1);
const [groupCroppedPixels, setGroupCroppedPixels] = useState(null);
const [showGroupCropper, setShowGroupCropper] = useState(false);
const [planImageUrl, setPlanImageUrl] = useState(null); // server URL
const [isUploadingImage, setIsUploadingImage] = useState(false);
const [devotionalImageUrl, setDevotionalImageUrl] = useState(null); // server URL
const [isDevotionalImageUploading, setIsDevotionalImageUploading] = useState(false);
const [availableUser,setavailableUser]=useState([]);
const [searchTerm, setSearchTerm] = useState("");
const [filteredUsers, setFilteredUsers] = useState([]);

const bibleFileInputRef = useRef(null);

const [bibleImageSrc, setBibleImageSrc] = useState(null);
const [bibleCroppedImage, setBibleCroppedImage] = useState(null);
const [bibleImageUrl, setBibleImageUrl] = useState(null);
const isBibleImageUploaded = Boolean(bibleImageUrl);

const [bibleCrop, setBibleCrop] = useState({ x: 0, y: 0 });
const [bibleZoom, setBibleZoom] = useState(1);
const [bibleCroppedPixels, setBibleCroppedPixels] = useState(null);
const [showBibleCropper, setShowBibleCropper] = useState(false);

const [youtubeUrl, setYoutubeUrl] = useState("");
const onBibleImageSelect = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = () => {
    setBibleImageSrc(reader.result);
    setShowBibleCropper(true);
  };
  reader.readAsDataURL(file);
};

const onBibleCropComplete = (_, croppedPixels) => {
  setBibleCroppedPixels(croppedPixels);
};
useEffect(() => {
  if (church?._id) {
    dispatch(readGalleryRequest({ churchObjId: church._id }));
  }
}, [church?._id]);

const handleBibleCropSave = async () => {
  try {
    const croppedFile = await getCroppedImg(
      bibleImageSrc,
      bibleCroppedPixels,
      `bible-plan-${Date.now()}.jpg`
    );

    const previewUrl = URL.createObjectURL(croppedFile);
    setBibleCroppedImage(previewUrl);

    const formData = new FormData();
    formData.append("file", croppedFile);
    formData.append("uploadType", "group"); // ✅ SAME API as group

    dispatch(
      uploadAssestsAction({
        apiPayloadRequest: formData,
        callback: (res) => {
          if (res?.url) {
            setBibleImageUrl(res.url);
            toast.success("Bible plan image uploaded");
          } else {
            toast.error(res?.error || "Image upload failed");
          }
        },
      })
    );

    setShowBibleCropper(false);
  } catch (err) {
    toast.error("Failed to process image");
  }
};

useEffect(() => {
  if (!editData) return;


  // Basic info
  setGroupName(editData.groupName || "");
  setGroupImageUrl(editData.groupCoverImageUrl || null);

  // Members (store userAuthId only – matches your logic)
  setSelectedMembers(
    (editData.groupMembers || []).map(m => m.userAuthId)
  );

  // Plans & content
  setSelectedBiblePlans(editData.biblePlan || []);
  setSavedDevotionals(editData.devotionals || []);
  setSelectedJournals(editData.journals || []);
  setSelectedVideos(editData.videos || []);
  setsavedCurriculum(editData.curriculums || []);
  setSavedTestimonials(editData.testimonies || []);

}, [editData]);

const onGroupImageSelect = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = () => {
    setGroupImageSrc(reader.result);
    setShowGroupCropper(true);
  };
  reader.readAsDataURL(file);
};
const onGroupCropComplete = (_, croppedPixels) => {
  setGroupCroppedPixels(croppedPixels);
};
const handleGroupCropSave = async () => {
  try {
    setIsUploadingImage(true);

    const croppedFile = await getCroppedImg(
      groupImageSrc,
      groupCroppedPixels,
      `group-image-${Date.now()}.jpg`
    );

    // Preview
    const previewUrl = URL.createObjectURL(croppedFile);
    setGroupCroppedImage(previewUrl);

    // Prepare FormData
    const formData = new FormData();
    formData.append("file", croppedFile);
    formData.append("uploadType", "group");

    dispatch(
      uploadAssestsAction({
        apiPayloadRequest: formData,
        callback: (res) => {
                    if (res?.url) {
            setGroupImageUrl(res.url);
            toast.success("Group image uploaded successfully");
          } else {
            toast.error(res?.error || "Failed to upload group image");
          }
          setIsUploadingImage(false);
        },
      })
    );

    setShowGroupCropper(false);
  } catch (error) {
        toast.error("Failed to process group image");
    setIsUploadingImage(false);
  }
};

  useEffect(() => {
    dispatch(
      testimonialReadAction({
        apiPayloadRequest: { approval_status: "1" },
        callback: (res) => {
          const data = res?.data?.filter((item) => item.approval_status === 1);
          setAllTestimonials(data || []);
        },
      })
    );

  }, []);
  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredUsers(availableUser);
      return;
    }

    const lowerSearch = searchTerm.toLowerCase();

    const filtered = availableUser.filter((user) =>
      `${user.firstName || ""} ${user.lastName || ""}`
        .toLowerCase()
        .includes(lowerSearch)
    );

    setFilteredUsers(filtered);
  }, [searchTerm, availableUser]);

 useEffect(() => {
    dispatch(
      curriculumReadAction({
        callback: (res) => {
          if (res?.type === 1) {
                        setCurriculumData(res?.data);
          }
        },
      })
    );

  }, []);
const onDevotionalImageSelect = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = () => {
    setDevotionalImageSrc(reader.result);
    setShowDevotionalCropper(true);
  };
  reader.readAsDataURL(file);
};
const onDevotionalCropComplete = (_, croppedPixels) => {
  setDevotionalCroppedPixels(croppedPixels);
};


const handleDevotionalCropSave = async () => {
  try {
    setIsDevotionalImageUploading(true);

    const croppedFile = await getCroppedImg(
      devotionalImageSrc,
      devotionalCroppedPixels,
      `devotional-${Date.now()}.jpg`
    );

    // Local preview
    const previewUrl = URL.createObjectURL(croppedFile);
    setDevotionalCroppedImage(previewUrl);

    // Prepare FormData
    const formData = new FormData();
    formData.append("file", croppedFile);
    formData.append("uploadType", "devotional");

    dispatch(
      uploadAssestsAction({
        apiPayloadRequest: formData,
        callback: (res) => {
                    if (res?.url) {
            setDevotionalImageUrl(res.url);
            toast.success("Devotional image uploaded");
          } else {
            toast.error(res?.error || "Failed to upload image");
          }
          setIsDevotionalImageUploading(false);
        },
      })
    );

    setShowDevotionalCropper(false);
  } catch (error) {
        toast.error("Failed to process devotional image");
    setIsDevotionalImageUploading(false);
  }
};


  const fetchJournals = () => {

    dispatch(
      getJournalsAction({
        apiPayloadRequest: { public: "true" },
        callback: (response) => {
                    setJournals(response?.data);
        },
      })
    );
  };
  const fetchVideos = () => {
     dispatch(
      readVideoAction({

        callback: (response) => {
                    setVideos(response?.data);
        },
      })
    );
  };
    useEffect(() => {
    fetchJournals();
    fetchVideos()
  }, []);
const onSelectImage = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = () => {
    setImageSrc(reader.result);
    setShowCropper(true);
  };
  reader.readAsDataURL(file);
};
const onCropComplete = (_, croppedPixels) => {
  setCroppedAreaPixels(croppedPixels);
};
const getCroppedImg = async (imageSrc, crop, fileName) => {
  const image = new window.Image();
  image.src = imageSrc;

  await new Promise((resolve) => (image.onload = resolve));

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  canvas.width = crop.width;
  canvas.height = crop.height;

  ctx.drawImage(
    image,
    crop.x,
    crop.y,
    crop.width,
    crop.height,
    0,
    0,
    crop.width,
    crop.height
  );

  return new Promise((resolve) => {
    canvas.toBlob((blob) => {
      // Convert Blob to File
      const file = new File([blob], fileName, {
        type: "image/jpeg",
        lastModified: Date.now(),
      });
      resolve(file);
    }, "image/jpeg", 0.95); // 0.95 quality for better compression
  });
};
const handleCropSave = async () => {
  try {
    setIsUploadingImage(true);

    // Get cropped image as File
    const croppedFile = await getCroppedImg(
      imageSrc,
      croppedAreaPixels,
      `plan-cover-${Date.now()}.jpg`
    );

    // Local preview (optional)
    const previewUrl = URL.createObjectURL(croppedFile);
    setCroppedImage(previewUrl);

    // Prepare FormData for upload
    const formData = new FormData();
    formData.append("file", croppedFile);
    formData.append("uploadType", "group"); // or "plan" based on your API

    // Upload using the correct structure
    dispatch(
      uploadAssestsAction({
        apiPayloadRequest: formData, // Send FormData directly
        callback: (res) => {
                    if (res?.url) {
            setPlanImageUrl(res.url); // ✅ SERVER URL
            toast.success("Image uploaded successfully");
          } else {
            toast.error(res?.error || "Failed to upload image");
          }
          setIsUploadingImage(false);
        },
      })
    );

    setShowCropper(false);
  } catch (error) {
        toast.error("Failed to process image");
    setIsUploadingImage(false);
  }
};


const handleAddBiblePlan = (plan) => {
    setSelectedBiblePlans((prev) => {
    const exists = prev.find((p) => p._id === plan._id);
    if (exists) return prev;
    return [...prev, plan];
  });
};
const handleAddDevotional = (devotional) => {
    setSavedDevotionals((prev) => {
    const exists = prev.find((d) => d._id === devotional._id);
    if (exists) return prev;

    // Ensure the devotional has the right structure
    return [...prev, {
      _id: devotional._id,
      devotionalTitle: devotional.devotionalTitle,
      image: devotional.image || ChristmasImage,
      devotionalDescription: devotional.devotionalDescription,
    }];
  });
};

const handleAddTestimonialPlan = (plan) => {
    setSavedTestimonials((prev) => {
    const exists = prev.find((p) => p._id === plan._id);
    if (exists) return prev;
    return [...prev, plan];
  });
};
const handleAddJournal = (plan) => {
    setSelectedJournals((prev) => {
    const exists = prev.find((p) => p._id === plan._id);
    if (exists) return prev;
    return [...prev, plan];
  });
};
const handleAddVideos = (plan) => {
    setSelectedVideos((prev) => {
    const exists = prev.find((p) => p._id === plan._id);
    if (exists) return prev;
    return [...prev, plan];
  });
};
const handleAddCurriculum = (plan) => {
    setsavedCurriculum((prev) => {
    const exists = prev.find((p) => p._id === plan._id);
    if (exists) return prev;
    return [...prev, plan];
  });
};
  const createEmptyPlan = (day) => ({
    title: "",
    day,
    description: "",
    verses: [],

  });

  const [plans, setPlans] = useState([createEmptyPlan(1)]);

  const handleNext = () => {
    const currentIndex = MENU_ITEMS.findIndex((m) => m.id === activeMenu);
    if (currentIndex < MENU_ITEMS.length - 1) {
      setActiveMenu(MENU_ITEMS[currentIndex + 1].id);
    }
    if (showPlanBuilder) setShowPlanBuilder(false);
  };
  const dispatch = useDispatch();

  const handleCreatePlanFromYoutube = () => {
    if (!youtubeUrl?.trim()) {
      toast.error("Please paste a YouTube link");
      return;
    }

    if (!selectedGalleryImage) {
      toast.error("Please select a cover image from gallery");
      return;
    }
    setIsCreatingPlan(true);

    // Step 1: Save YouTube Plan
    dispatch(
      saveYoutubePlanAction({
        data: {
          youtubeurl: youtubeUrl.trim(),
        },
        callback: async (res) => {
          if (res.type !== 1) {
            toast.error(res.error || "Failed to create YouTube plan");
            return;
          }

          toast.success("YouTube plan created successfully");
          const plansArray = res.data?.plans || [];

          const noOfDays = plansArray.length;

          // Step 2: Save Plan
          const planPayload = {
            planName: planName.trim(),
            noofDays: noOfDays,
            galleryObjId: selectedGalleryImage._id,
            churchObjId: church?._id,
            typeonplan: 2
          };

          dispatch(
            savePlanRequest(planPayload, async (savedPlan) => {
              toast.success("Plan saved successfully!");
              const planObjId = savedPlan?.data?.[0]?._id;

              // Step 3: Save Day Plans sequentially
              for (let i = 0; i < plansArray.length; i++) {
                const dayItem = plansArray[i];
                const dayPayload = {
                  _id: planObjId,
                  dayNumber: i + 1,
                  dayplanname: dayItem.title || `Day ${i + 1}`,
                  dayplandescription: `
                Prayer:
                ${dayItem.prayer || ""}

                Summary:
                ${dayItem.summary || ""}

                Takeaway:
                ${dayItem.takeaway || ""}
                `.trim(),
                };


                const dayplanObjId = await new Promise((resolveDay) => {
                  dispatch(
                    saveDayPlanRequest(dayPayload, (dayRes) => {
                      if (dayRes.type === 1) {
                                                resolveDay(dayRes.dayplanObjId || dayRes._id);
                      } else {
                                                resolveDay(null);
                      }
                    })
                  );
                });

                if (!dayplanObjId) continue; // skip if failed

                // Step 4: Bible Search for verse
                if (!dayItem.verse) continue;

                const bibleRes = await new Promise((resolveBible) => {
                  dispatch(
                    getBibleSearchAction({
                      apiPayloadRequest: { question: dayItem.verse },
                      callback: (bRes) => {
                                                resolveBible(bRes?.data || []);
                      },
                    })
                  );
                });

                // Step 5: Save Bible Details sequentially
                for (let j = 0; j < bibleRes.length; j++) {
                  const verse = bibleRes[j];
                  const detailPayload = {
                    _id: planObjId,
                    dayplanObjId,
                    bookId: verse.book_id,
                    bookName: verse.book_name,
                    chapterId: String(verse.chapter),
                    verseStart: String(verse.verse_start),
                    verseText: verse.verse_text,
                    versionid: verse.filesetid,
                    youtubevideourl: dayItem.videoSnippetUrl || "",
                  };
                    await new Promise((resolveDetail) => {
                    dispatch(
                      saveDayPlanDetailRequest(detailPayload, () => {
                                                resolveDetail();
                      })
                    );
                  });
                }
              }

              toast.success("All day plans and details saved successfully!");
              setIsCreatingPlan(false);

            })
          );
        },
      })
    );
  };






  useEffect(() => {
    // Log before dispatch

    dispatch(availableUsersAction({
      // Add any parameters if needed
      callback: (res) => {
                                setavailableUser(res.data);

        if (res.type === 1) {
                  } else {
                  }
      }
    }));


  }, [dispatch]);

  useEffect(() => {
    if (activeMenu === "members") {
      dispatch(
        myCircleListAction({
          circlerequeststatus: "1", // accepted members
        })
      );
    }
  }, [activeMenu, dispatch]);
  const { myCircle, loading } = useSelector(
    (state) => state.user
  );

  const handleSearch = (search) => {
        setIsSearching(true);

    if (!search?.trim()) {
      setSearchResults([]);
      setIsSearching(false);
      return;
    }

    dispatch(
      getBibleSearchAction({
        apiPayloadRequest: {
          question: search, // only pass question
        },
        callback: (res) => {
                    setSearchResults(res?.data ?? []);
          setIsSearching(false);
        },
      })
    );
  };


  useEffect(() => {
    if (searchTxt?.length >= 3 && newVerseActive) {
      const delay = setTimeout(() => {
        handleSearch(searchTxt);
      }, 400); // debounce

      return () => clearTimeout(delay);
    }
  }, [searchTxt, newVerseActive, versionDetails]);
  const handleSavePlan = async () => {
    if (!planName.trim()) {
      toast.error("Plan name is required");
      return;
    }

    // 1️⃣ Save main plan first
    dispatch(
      savePlanAction({
        planName,
        description: planDescription,
        plansCoverImageUrl: planImageUrl || "", // ✅ added

        callback: async (res) => {
          if (res.type !== 1) {
            toast.error(res?.error || "Failed to save plan");
            return;
          }

          toast.success(res?.data?.message || "Plan saved successfully");

          const planId = res?.data?.data?.[0]?._id;
          if (!planId) return;


          // 2️⃣ Save day plans sequentially
          for (const dayPlan of plans) {
            // Each dayPlan may have multiple verses
            for (const verse of dayPlan.verses) {
              await new Promise((resolve) => {
                dispatch(
                  saveDayPlanAction({
                    _id: planId,
                    dayNumber: dayPlan.day,
                    dayplanname: dayPlan.title,
                    dayplandescription: dayPlan.description,
                    youtubevideourl: dayPlan.youtubeUrl || "",
                    versionid: verse.filesetid,
                    bookId: verse.book_id,
                    chapterId: verse.chapter,
                    verseStart: verse.verse_start,
                    bookName: verse.book_name,
                    verseText: verse.verse_text,
                    callback: () => resolve(), // resolve after saveDayPlan finishes
                  })
                );
              });
            }
          }

          // 3️⃣ Reset UI
          setShowPlanBuilder(false);
          setPlanName("");
          setPlanDescription("");
        },
      })
    );
  };

  useEffect(() => {
    // Fetch all saved plans when component mounts
    dispatch(
      readPlanAction({
        callback: (res) => {
          if (res.type === 1) {
             // log the plans
            setAllPlans(res.data)
          } else {
                      }
        },
      })
    );
  }, [dispatch]);
  const removeBiblePlan = (id) => {
    setSelectedBiblePlans((prev) => prev.filter((p) => p._id !== id));
  };

  const removeJournal = (id) => {
    setSelectedJournals((prev) => prev.filter((p) => p._id !== id));
  };

  const removeVideo = (id) => {
    setSelectedVideos((prev) => prev.filter((p) => p._id !== id));
  };

  const removeDevotional = (id) => {
    setSavedDevotionals((prev) => prev.filter((p) => p._id !== id));
  };

  const removeCurriculum = (id) => {
    setsavedCurriculum((prev) => prev.filter((p) => p._id !== id));
  };

  const removeTestimonial = (id) => {
    setSavedTestimonials((prev) => prev.filter((p) => p._id !== id));
  };
      return (
    <>
    <div className={`py-10 flex text-white items-center gap-[5%]  max-w-full w-full pl-4`}>
      {/* Left Section */}
      <div className="w-[65%] pt-0">
        <h1 className="text-xl font-semibold text-[#F8BA34] mb-6">
  {isEditMode ? "Edit Group" : "Create Group"}
</h1>

        <div className="flex justify-between items-center">
        <div className="flex flex-col items-center justify-center mb-4 cursor-pointer">
  {/* Clickable image area */}
  <div
    className="relative w-full flex justify-center"
    onClick={() => groupFileInputRef.current.click()}
  >
    {groupImageUrl ? (
      <img
        src={groupImageUrl}
        alt="Group"
        className="max-w-[400px] max-h-[400px] mb-8 border-2 border-green-500"
      />
    ) : groupCroppedImage ? (
      <img
        src={groupCroppedImage}
        alt="Group Preview"
        className="max-w-[400px] max-h-[400px] mb-8 border-2 border-yellow-500"
      />
    ) : (
      <div className="relative">
        <img
          src={UploadImage}
          className="opacity-25 border-2 border-red-500"
          alt="Upload group image"
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-red-500 font-bold text-lg">* Required</span>
        </div>
      </div>
    )}

    {/* Hidden file input */}
    <input
      type="file"
      accept="image/*"
      ref={groupFileInputRef}
      onChange={onGroupImageSelect}
      className="hidden"
    />
  </div>

  <input
    type="text"
    placeholder="New Group Name"
    value={groupName}
    onChange={(e) => setGroupName(e.target.value)}
    className={`mt-2 w-full bg-transparent border-b ${
      !groupName ? 'border-red-500' : 'border-[#F8BA34]'
    } text-[#F8BA34] placeholder-[#F8BA34] placeholder-opacity-25 focus:outline-none`}
  />
  {!groupName && (
    <span className="text-red-500 text-sm mt-1">Group name is required</span>
  )}
</div>
          <div className="space-y-4">
          {MENU_ITEMS.map((item) => (
  <div key={item.id}>
    <div
     onClick={() => {
      setActiveMenu(item.id);
      setShowRightPanel(true);
    }}

      className={`cursor-pointer flex items-center gap-2 text-lg ${
        activeMenu === item.id
          ? "text-[#F8BA34] font-semibold"
          : "text-[#F8BA34] hover:opacity-100 opacity-25"
      }`}
    >
      <span className="text-[#F8BA34]">+</span>
      {item.label}
    </div>

    {/* ✅ SHOW SELECTED PLANS UNDER BIBLE PLAN */}
    {item.id === "plan" && selectedBiblePlans.length > 0 && (
      <div className="ml-6 mt-2 space-y-1 flex items-center gap-2">
        {selectedBiblePlans.map((plan) => (
           <div className="relative flex flex-col max-w-[80px] overflow-hidden">
              <IoClose
    className="absolute top-1 right-1 text-white bg-black/70 rounded-full cursor-pointer hover:text-red-500 z-10"
    onClick={(e) => {
      e.stopPropagation();
      removeBiblePlan(plan._id);
    }}
  />
           <img
             src={ChristmasImage}
             alt={plan.planName}
             className="w-full h-[100px] object-cover rounded-lg"
           />

           <div className="p-2 flex flex-col flex-1">
             <h3 className="text-sm font-semibold text-white truncate">
               {plan.planName}
             </h3>
           </div>
         </div>
        ))}
      </div>
    )}
        {item.id === "journals" && selectedJournals.length > 0 && (
      <div className="ml-6 mt-2 space-y-1 flex items-center gap-2">
        {selectedJournals.map((plan) => (
           <div className="relative flex flex-col max-w-[80px] overflow-hidden">
              <IoClose
    className="absolute top-1 right-1 text-white bg-black/70 rounded-full cursor-pointer hover:text-red-500 z-10"
    onClick={(e) => {
      e.stopPropagation();
      removeJournal(plan._id);
    }}
  />
           <img
             src={plan?.banner_Images?.[0]?.url_link ?? ChristmasImage}
             alt={plan.journal_title}
             className="w-full h-[100px] object-cover rounded-lg"
           />

           <div className="p-2 flex flex-col flex-1">
             <h3 className="text-sm font-semibold text-white truncate">
               {plan.journal_title}
             </h3>
           </div>
         </div>
        ))}
      </div>
    )}
        {item.id === "videos" && selectedVideos.length > 0 && (
      <div className="ml-6 mt-2 space-y-1 flex items-center gap-2">
        {selectedVideos.map((plan) => (

           <div className="relative flex flex-col max-w-[80px] overflow-hidden">
                         <IoClose
    className="absolute top-1 right-1 text-white bg-black/70 rounded-full cursor-pointer hover:text-red-500 z-10"
    onClick={(e) => {
      e.stopPropagation();
      removeVideo(plan._id);
    }}
  />
           <img
             src={plan?.tumbnailurls?.[0]?.url_link ?? ChristmasImage}
             alt={plan.video_title}
             className="w-full h-[100px] object-cover rounded-lg"
           />

           <div className="p-2 flex flex-col flex-1">
             <h3 className="text-sm font-semibold text-white truncate">
               {plan.video_title}
             </h3>
           </div>
         </div>
        ))}
      </div>
    )}
    {/* {item.id === "devotionals" && savedDevotionals.length > 0 && (
  <div className="ml-6 mt-2 space-y-1 flex items-center gap-2">
    {savedDevotionals.map((devotional) => (
      <div
        key={devotional.id}
        className=" relative flex flex-col max-w-[80px] overflow-hidden"
      >
                            <IoClose
    className="absolute top-1 right-1 text-white bg-black/70 rounded-full cursor-pointer hover:text-red-500 z-10"
    onClick={(e) => {
      e.stopPropagation();
      removeDevotional(devotional.id);
    }}
  />
        <img
          src={devotional.image}
          alt={devotional.title}
          className="w-full h-[100px] object-cover rounded-lg"
        />

        <div className="p-2 flex flex-col flex-1">
          <h3 className="text-sm font-semibold text-white truncate">
            {devotional.title}
          </h3>
        </div>
      </div>
    ))}
  </div>
)} */}
  {item.id === "curriculum" && savedCurriculum.length > 0 && (
  <div className="ml-6 mt-2 space-y-1 flex items-center gap-2">
    {savedCurriculum.map((devotional) => (
      <div
        key={devotional._id}
        className="relative flex flex-col max-w-[80px] overflow-hidden"
      >
                                <IoClose
    className="absolute top-1 right-1 text-white bg-black/70 rounded-full cursor-pointer hover:text-red-500 z-10"
    onClick={(e) => {
      e.stopPropagation();
      removeCurriculum(devotional._id);
    }}
  />
        <img
          src={devotional?.bg_Images?.[0]?.url_link ??ChristmasImage }
          alt={devotional.curriculum_name}
          className="w-full h-[100px] object-cover rounded-lg"
        />

        <div className="p-2 flex flex-col flex-1">
          <h3 className="text-sm font-semibold text-white truncate">
            {devotional.curriculum_name }
          </h3>
        </div>
      </div>
    ))}
  </div>
)}

 {item.id === "testimonial" && SavedTestimonials.length > 0 && (
  <div className="ml-6 mt-2 space-y-1 flex items-center gap-2">
    {SavedTestimonials.map((devotional) => (

      <div
        key={devotional._id}
        className="relative flex flex-col max-w-[80px] overflow-hidden"
      >
                                    <IoClose
    className="absolute top-1 right-1 text-white bg-black/70 rounded-full cursor-pointer hover:text-red-500 z-10"
    onClick={(e) => {
      e.stopPropagation();
      removeTestimonial(devotional._id);
    }}
  />
        <img
          src={devotional?.testomonial_rec_tumbnailUrl??ChristmasImage }
          alt={devotional.testimonial_name}
          className="w-full h-[100px] object-cover rounded-lg"
        />

        <div className="p-2 flex flex-col flex-1">
          <h3 className="text-sm font-semibold text-white truncate">
            {devotional.testimonial_name}
          </h3>
        </div>
      </div>
    ))}
  </div>
)}
{item.id === "devotionals" && savedDevotionals.length > 0 && (
  <div className="ml-6 mt-2 space-y-1 flex items-center gap-2">
    {savedDevotionals.map((devotional) => (
      <div key={devotional._id} className="relative flex flex-col max-w-[80px] overflow-hidden">
        <IoClose
          className="absolute top-1 right-1 text-white bg-black/70 rounded-full cursor-pointer hover:text-red-500 z-10"
          onClick={(e) => {
            e.stopPropagation();
            removeDevotional(devotional._id);
          }}
        />
        <img
          src={devotional.image || ChristmasImage}
          alt={devotional.devotionalTitle}
          className="w-full h-[100px] object-cover rounded-lg"
        />
        <div className="p-2 flex flex-col flex-1">
          <h3 className="text-sm font-semibold text-white truncate">
            {devotional.devotionalTitle}
          </h3>
        </div>
      </div>
    ))}
  </div>
)}
  </div>
))}
<button
  type="button"
  onClick={() => {
    // Validate required fields
    if (!groupName.trim()) {
      toast.error("Group name is required");
      return;
    }

    if (!groupImageUrl && !groupCroppedImage) {
      toast.error("Group image is required");
      return;
    }

    // Show loading state
    const action = isEditMode ? updateGroup : saveGroup;

    action({
      dispatch,
      ...(isEditMode && { _id: editData._id }), // ✅ only for update
      groupName,
      churchObjId: church?._id,
      groupImage: groupImageUrl,
      members: selectedMembers,
      plan: selectedBiblePlans,
      devotionals: savedDevotionals,
      journals: selectedJournals,
      videos: selectedVideos,
      curriculums: savedCurriculum,
      testimonies: SavedTestimonials,
      callback: (res) => {
        if (res.type === 1) {
          toast.success(
            isEditMode ? "Group updated successfully" : "Group created successfully"
          );

          if (!isEditMode) {
            // reset only on create
            setGroupName("");
            setGroupImageUrl(null);
            setGroupCroppedImage(null);
            setSelectedMembers([]);
            setSelectedBiblePlans([]);
            setSavedDevotionals([]);
            setSelectedJournals([]);
            setSelectedVideos([]);
            setsavedCurriculum([]);
            setSavedTestimonials([]);
          }
        } else {
          toast.error(res.error || "Failed to save group");
        }
      },
    });

  }}
  className="mt-8 bg-[#F8BA34] text-black px-6 py-3 rounded-xl font-semibold hover:bg-yellow-500 transition"
>
{isEditMode ? "Update Group" : "Create Group"} +

</button>




          </div>
        </div>
      </div>

      {/* Right Section */}
      {showRightPanel && (
      <div className="w-[35%] p-10 bg-[#2a2a2a] rounded-l-3xl max-h-[600px] overflow-y-auto relative">
           <IoClose
      onClick={() => setShowRightPanel(false)}
  className="absolute right-5 top-5 cursor-pointer"
    />
      {activeMenu === "members" && (
  <>
    {/* Top avatars */}
    <div className="flex items-center justify-between mb-4">
    <div className="flex items-center">
  {availableUser.slice(0, 6).map((item, i) => (
    <img
      key={item._id}
      src={item?.profilePicUrl}
      alt="avatar"
      className="w-10 h-10 rounded-full border-2 border-[#F8BA34] -ml-3 first:ml-0 object-cover"
      style={{ zIndex: 10 - i }}
    />
  ))}

  {availableUser.length > 6 && (
    <div
      className="w-10 h-10 rounded-full bg-[#F8BA34] text-black font-semibold flex items-center justify-center text-sm -ml-3 border-2 border-[#F8BA34]"
      style={{ zIndex: 0 }}
    >
      +{availableUser.length - 6}
    </div>
  )}
</div>


      <ArrowRight
        onClick={handleNext}
        className="text-white w-6 h-6 cursor-pointer"
      />
    </div>

    {/* Search */}
    <div className="relative mb-4 mt-16">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" />
      <input
  type="text"
  placeholder="Search"
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
  className="w-full pl-10 pr-4 py-2 rounded-[10px] bg-[#2a2a2a] text-white border border-[#a3a3a3]"
/>

    </div>

    {/* Members List */}
    <div className="max-h-[300px] overflow-y-auto">


      { filteredUsers.length === 0 && (
        <p className="text-center text-gray-400 py-4">
          No members found
        </p>
      )}

      {availableUser &&
   filteredUsers.map((item) => {
    const isSelected = selectedMembers.includes(item.userAuthId);

    return (
      <MemberCard
      key={item.userAuthId}
      name={`${item?.firstName} ${item?.lastName || ""}`}
      profilePic={item?.profilePicUrl}
      circleName="My Circle"
      isSelected={isSelected}
      onClick={() => {
        setSelectedMembers((prev) =>
          prev.includes(item.userAuthId)
            ? prev.filter((id) => id !== item.userAuthId) // deselect
            : [...prev, item.userAuthId]                  // select
        );
      }}
    />
    );
  })

    }
    </div>
  </>
)}


{activeMenu === "plan" && (
  <BiblePlan
    onNext={handleNext}
    onCreatePlan={() => setShowPlanBuilder(true)}
    plan={allPlans}
    onAddPlan={handleAddBiblePlan}
  />
)}
{activeMenu === "curriculum" && (
  <CurriculumPlan
    onNext={handleNext}
    onCreatePlan={() => setShowPlanBuilder(true)}
    curriculum={CurriculumData}
    onAddPlan={handleAddCurriculum}
  />
)}
{activeMenu === "journals" && (
  <JournalsPlan
    onNext={handleNext}
    onCreatePlan={() => setShowPlanBuilder(true)}
    journal={journals}
    onAddPlan={handleAddJournal}
  />
)}
{activeMenu === "testimonial" && (
  <TestimonialPlan
    onNext={handleNext}
    onCreatePlan={() => setShowPlanBuilder(true)}
    testimonial={AllTestimonials}
    onAddPlan={handleAddTestimonialPlan}
  />
)}
{activeMenu === "videos" && (
  <VideosPlan
    onNext={handleNext}
    onCreatePlan={() => setShowPlanBuilder(true)}
    videos={videos}
    onAddPlan={handleAddVideos}
  />
)}
       {activeMenu === "bible" && !showPlanBuilder && (
  <div className="flex flex-col h-full">
    {/* Header */}
    <div className="grid grid-flow-col justify-between items-center mb-6">
      <span className="flex items-center gap-3 w-full">
        <input
          type="text"
          placeholder="Plan Name"
          value={planName}
          onChange={(e) => setPlanName(e.target.value)}
          className="flex-1 bg-transparent border-b border-gray-400 focus:outline-none text-lg"
        />

<ImagePlus
  className="text-white cursor-pointer"
  onClick={() => setShowGalleryModal(true)}
/>


        <input
          type="file"
          accept="image/*"
          ref={bibleFileInputRef}
          onChange={onBibleImageSelect}
          className="hidden"
        />

        {(bibleImageUrl || bibleCroppedImage) && (
          <img
            src={bibleImageUrl || bibleCroppedImage}
            alt="Bible Plan"
            className="w-10 h-10 rounded-full object-cover border border-[#F8BA34]"
          />
        )}
      </span>

      <ArrowRight
        onClick={handleNext}
        className="ml-4 text-white w-6 h-6 cursor-pointer"
      />
    </div>

    {/* YouTube URL */}
    <input
      type="text"
      placeholder="Paste YouTube sermon link"
      value={youtubeUrl}
      onChange={(e) => setYoutubeUrl(e.target.value)}
      className="mb-6 bg-transparent border-b border-gray-400 focus:outline-none text-sm text-white"
    />

  {/* Content */}
<div className="flex-1 flex flex-col justify-center items-center gap-6 w-[60%] mt-9">

{/* 🔁 Show image AFTER successful upload */}
{selectedGalleryImage && (
  <div className="w-full flex justify-center">
    <img
      src={selectedGalleryImage.imageUrlDesktop || selectedGalleryImage.imageUrl}
      alt={selectedGalleryImage.imageName}
      className="w-full max-w-[320px] h-[200px] object-cover rounded-xl border-2 border-[#F8BA34]"
    />
  </div>
)}


{/* Button does NOTHING for now */}
<button
  onClick={handleCreatePlanFromYoutube}
  disabled={!youtubeUrl || isCreatingPlan}
  className={`flex items-center justify-center gap-3 font-semibold px-6 py-3 rounded-xl transition shadow-md
    ${
      isCreatingPlan
        ? "bg-[#F8BA34]/40 cursor-not-allowed"
        : youtubeUrl
        ? "bg-[#F8BA34] hover:bg-yellow-500"
        : "bg-[#F8BA34]/40 cursor-not-allowed"
    }`}
>
  <span>
    {isCreatingPlan ? "Creating plan..." : "Create your own plan"}
  </span>

  {isCreatingPlan && (
    <span className="w-4 h-4 border-2 border-black border-t-transparent rounded-full animate-spin" />
  )}
</button>




</div>

  </div>
)}

{activeMenu === "devotionals" && (
  <>
    {/* Show DevotionalPlan component OR creation form, not both */}
    {!showDevotionalForm ? (
      <DevotionalPlan
        onNext={handleNext}
        onCreatePlan={() => {
          // Show the devotional creation form
          setShowDevotionalForm(true);
        }}
        onAddPlan={handleAddDevotional}
      />
    ) : (
      <div className="flex flex-col h-full">
        <div className="grid grid-flow-col justify-between items-center mb-6">
          <span className="flex items-center gap-3">
            <ArrowLeft
              className="text-white w-6 h-6 cursor-pointer"
              onClick={() => {
                setShowDevotionalForm(false);
                // Reset form fields when going back
                setDevotionalTitle("");
                setDevotionalCroppedImage(null);
                setPlans([createEmptyPlan(1)]);
                setSelectedJournals([]);
                setSavedTestimonials([]);
              }}
            />
            <input
              type="text"
              placeholder="New Devotional Name"
              value={devotionalTitle}
              onChange={(e) => setDevotionalTitle(e.target.value)}
              className="flex-1 bg-transparent border-b border-gray-400 focus:outline-none text-lg"
            />

            <ImagePlus
              className="text-white cursor-pointer"
              onClick={() => devotionalFileInputRef.current.click()}
            />

            <input
              type="file"
              accept="image/*"
              ref={devotionalFileInputRef}
              onChange={onDevotionalImageSelect}
              className="hidden"
            />

{devotionalImageUrl ? (
  <img
    src={devotionalImageUrl}
    alt="Devotional"
    className="w-10 h-10 rounded-full object-cover border border-[#F8BA34]"
  />
) : devotionalCroppedImage ? (
  <img
    src={devotionalCroppedImage}
    alt="Devotional Preview"
    className="w-10 h-10 rounded-full object-cover border border-[#F8BA34]"
  />
) : null}

          </span>

          <ArrowRight
            onClick={handleNext}
            className="ml-4 text-white w-6 h-6 cursor-pointer"
          />
        </div>

        <DevotionCard
          plan={plans[0]}
          journals={journals}
          testimonials={AllTestimonials}
          onAddVerse={() => {
            setActivePlanIndex(0);
            setNewVerseActive(true);
          }}
          onChange={(updatedPlan) =>
            setPlans((prev) =>
              prev.map((p, i) => (i === 0 ? updatedPlan : p))
            )
          }
          selectedJournals={selectedJournals}
          selectedTestimonials={SavedTestimonials}
          onJournalsChange={setSelectedJournals}
          onTestimonialsChange={setSavedTestimonials}
        />

        <div className="flex gap-4 mt-6">
          <button
            onClick={() => {
              if (!devotionalTitle || !devotionalCroppedImage) {
                toast.error("Devotional title and image are required");
                return;
              }

              saveDevotional({
                dispatch,
                devotionalName: devotionalTitle,
                description: plans[0]?.description || "",
                image: devotionalImageUrl, // ✅ FINAL URL
                journals: selectedJournals,
                testimonies: SavedTestimonials,
                verses: plans[0]?.verses || [],
                youtubeUrl: plans[0]?.youtubeUrl || "",
                callback: (res) => {
                  if (res.type === 1) {
                    // Get the devotional ID from the response
                    const devotionalId = res.data?.devotional?.data?.data?.[0]?._id || Date.now().toString();

                    // Add to saved devotionals with proper structure
                    setSavedDevotionals((prev) => [
                      ...prev,
                      {
                        _id: devotionalId,
                        devotionalTitle: devotionalTitle,
                        image: devotionalCroppedImage,
                        devotionalDescription: plans[0]?.description || "",
                      },
                    ]);

                    // Reset all fields and go back to devotional plan view
                    setDevotionalTitle("");
                    setDevotionalCroppedImage(null);
                    setDevotionalImageUrl(null);
                    setPlans([createEmptyPlan(1)]);
                    setSelectedJournals([]);
                    setSavedTestimonials([]);
                    setShowDevotionalForm(false);

                    toast.success(res.data?.message || "Devotional saved successfully");
                  } else {
                    toast.error(res.error || "Failed to save devotional");
                  }
                },
              });
            }}
            className="bg-[#F8BA34] text-black px-6 py-2 rounded-[50px] font-semibold"
          >
            Save
          </button>

          <button
            onClick={() => {
              setShowDevotionalForm(false);
              // Reset form fields when canceling
              setDevotionalTitle("");
              setDevotionalCroppedImage(null);
              setPlans([createEmptyPlan(1)]);
              setSelectedJournals([]);
              setSavedTestimonials([]);
            }}
            className="border border-[#F8BA34] text-[#a3a3a3] px-6 py-2 rounded-[50px] font-semibold"
          >
            Cancel
          </button>
        </div>
      </div>
    )}
  </>
)}

      </div>
)}
      {showPlanBuilder && (
        <div className="fixed top-[10%] right-0 w-[90%] bg-[#2a2a2a] text-white p-8 pr-0 z-50 flex flex-col rounded-l-[25px]">
          <div className="flex justify-between items-center mb-6 pr-8">
            <div className="flex items-center gap-4">
              <ArrowLeft className="w-6 h-6 cursor-pointer" onClick={() => setShowPlanBuilder(false)} />
              <input
  type="text"
  placeholder="Plan Name"
  value={planName}
  onChange={(e) => setPlanName(e.target.value)}
  className="bg-transparent border-b border-gray-400 focus:outline-none text-lg"
/>

<input
  type="text"
  placeholder="Plan Description"
  value={planDescription}
  onChange={(e) => setPlanDescription(e.target.value)}
  className="bg-transparent border-b border-gray-400 focus:outline-none text-lg"
/>

<ImagePlus
  className="ml-4 text-[#A3A3A3] cursor-pointer"
  onClick={() => fileInputRef.current.click()}
/>

<input
  type="file"
  accept="image/*"
  ref={fileInputRef}
  onChange={onSelectImage}
  className="hidden"
/>
{planImageUrl ? (
  <img
    src={planImageUrl}
    alt="Plan"
    className="w-10 h-10 rounded-full object-cover border border-[#F8BA34]"
  />
) : croppedImage ? (
  <img
    src={croppedImage}
    alt="Plan Preview"
    className="w-10 h-10 rounded-full object-cover border border-[#F8BA34]"
  />
) : null}


            </div>
            <ArrowRight className="text-[#A3A3A3] w-6 h-6 cursor-pointer" />
          </div>
          <div className="flex-1 overflow-x-auto bg-[#1a1a1a]">
            <div className="flex gap-6 rounded-l-[25px] p-4">
            {plans.map((plan, idx) => (
  <PlanCard
    key={idx}
    plan={plan}
    onChange={(updatedPlan) =>
      setPlans((prev) =>
        prev.map((p, i) => (i === idx ? updatedPlan : p))
      )
    }
    onAddVerse={() => {
      setActivePlanIndex(idx);
      setNewVerseActive(true);
    }}
  />
))}

           <span
  onClick={() =>
    setPlans((prev) => [...prev, createEmptyPlan(prev.length + 1)])
  }
  className="text-[#F8BA34] font-semibold pt-4 flex min-w-[220px] cursor-pointer"
>

                <Plus className="text-[#F8BA34] w-6 h-6 mr-2 border-2 border-[#F8BA34] rounded-full" />
                Add plan for another day
              </span>
            </div>
          </div>
          <div className="flex gap-4 mt-6">
          <button
  onClick={handleSavePlan}
  className="bg-[#F8BA34] text-black px-6 py-2 rounded-[50px] font-semibold"
>
  Save
</button>

            <button className="border border-[#F8BA34] text-[#a3a3a3] px-6 py-2 rounded-[50px] font-semibold">Save Draft</button>
          </div>
        </div>
      )}
    </div>
    {newVerseActive && (
  <div className="fixed inset-0 z-50 bg-black/60 flex justify-center items-start pt-24">
    <div
      className="w-[600px] rounded-2xl bg-greyishV2 p-4"
      onClick={(e) => e.stopPropagation()}
    >
      {/* Search Header */}
      <div className="flex items-center gap-3 mb-4">
      <input
  type="text"
  value={searchTxt}
  placeholder="Search the Bible"
  onChange={(e) => setSearchTxt(e.target.value)}
  onKeyDown={(e) => {
    if (e.key === "Enter") handleSearch(searchTxt);
  }}
  className="flex-1 bg-greyish px-3 py-2 rounded-md text-white outline-none placeholder:text-gray-400"
/>

<button
  onClick={() => handleSearch(searchTxt)}
  className="bg-white px-3 py-2 rounded-md"
>
  Search
</button>

        <button
          onClick={() => setNewVerseActive(false)}
          className="text-white text-xl"
        >
          ✕
        </button>
      </div>

      {/* Results */}
      <div className="max-h-[300px] overflow-y-auto space-y-2">
        {isSearching && (
          <p className="text-center text-yellowish">
            Loading results...
          </p>
        )}
{!isSearching && searchResults?.length > 0 &&
  searchResults.map((item, index) => (

            <div
              key={index}
            className="p-3 rounded-md cursor-pointer bg-[#2a2a2a] hover:bg-[#333]"
              onClick={() => {
                // ✅ ADD VERSE TO PLAN
                setPlans((prev) =>
                  prev.map((plan, i) =>
                    i === activePlanIndex
                      ? {
                          ...plan,
                          verses: [
                            ...plan.verses,
                            {
                              book_id: item.book_id,
                              book_name: item.book_name,
                              chapter: item.chapter,
                              verse_start: item.verse_start,
                              verse_end: item.verse_end,
                              verse_text: item.verse_text,
                              filesetid: item.filesetid,
                            },
                          ],

                        }
                      : plan
                  )
                );

                setNewVerseActive(false);
                setSearchTxt("");
                setSearchResults([]);
              }}
            >
              <p className="text-white text-sm">
                {item.verse_text}
              </p>
              <p className="text-xs text-gray-400 mt-1">
                {item.book_name} {item.chapter}:{item.verse_start}
              </p>
            </div>
          ))}

        {!isSearching && searchResults.length === 0 && searchTxt && (
          <p className="text-center text-gray-400 py-6">
            No results found
          </p>
        )}
      </div>
    </div>
  </div>
)}
{showCropper && imageSrc && (
  <div className="fixed inset-0 z-[999] bg-black/70 flex items-center justify-center">
    <div className="bg-[#1a1a1a] w-[420px] h-[480px] rounded-2xl p-4 flex flex-col">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-white font-semibold">Crop Image</h3>
        <button
          onClick={() => setShowCropper(false)}
          className="text-gray-400 hover:text-white"
        >
          ✕
        </button>
      </div>

      {/* Cropper Area */}
      <div className="relative flex-1">
        <Cropper
          image={imageSrc}
          crop={crop}
          zoom={zoom}
          aspect={1}
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={onCropComplete}
        />
      </div>

      {/* Zoom Control */}
      <div className="mt-4">
        <input
          type="range"
          value={zoom}
          min={1}
          max={3}
          step={0.1}
          onChange={(e) => setZoom(parseFloat(e.target.value))}
          className="w-full"
        />
        <div className="flex justify-between text-xs text-gray-400 mt-1">
          <span>Zoom Out</span>
          <span>Zoom In</span>
        </div>
      </div>

      {/* Controls */}
      <div className="mt-4 flex justify-between items-center">
        <button
          onClick={() => setShowCropper(false)}
          className="text-gray-400 hover:text-white px-4 py-2"
          disabled={isUploadingImage}
        >
          Cancel
        </button>

        <button
          onClick={handleCropSave}
          disabled={isUploadingImage}
          className="bg-[#F8BA34] text-black px-6 py-2 rounded-lg font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isUploadingImage ? (
            <span className="flex items-center gap-2">
              <svg className="animate-spin h-4 w-4 text-black" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
              </svg>
              Uploading...
            </span>
          ) : (
            "Crop & Save"
          )}
        </button>
      </div>
    </div>
  </div>
)}
{showDevotionalCropper && (
  <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center">
    <div className="relative w-[400px] h-[400px] bg-[#1a1a1a] rounded-xl">
      <Cropper
        image={devotionalImageSrc}
        crop={devotionalCrop}
        zoom={devotionalZoom}
        aspect={1}
        onCropChange={setDevotionalCrop}
        onZoomChange={setDevotionalZoom}
        onCropComplete={onDevotionalCropComplete}
      />

      <div className="absolute bottom-4 right-4 flex gap-3">
        <button
          onClick={() => setShowDevotionalCropper(false)}
          className="px-4 py-1 text-white border rounded"
        >
          Cancel
        </button>
        <button
          onClick={handleDevotionalCropSave}
          className="px-4 py-1 bg-[#F8BA34] text-black rounded"
        >
          Crop
        </button>
      </div>
    </div>
  </div>
)}
{showGroupCropper && (
  <div className="fixed inset-0 z-[999] bg-black/70 flex items-center justify-center">
    <div className="relative w-[400px] h-[400px] bg-[#1a1a1a] rounded-xl">
      <Cropper
        image={groupImageSrc}
        crop={groupCrop}
        zoom={groupZoom}
        aspect={1}
        onCropChange={setGroupCrop}
        onZoomChange={setGroupZoom}
        onCropComplete={onGroupCropComplete}
      />

      <div className="absolute bottom-4 right-4 flex gap-3">
        <button
          onClick={() => setShowGroupCropper(false)}
          className="px-4 py-1 text-white border rounded"
        >
          Cancel
        </button>
        <button
          onClick={handleGroupCropSave}
          className="px-4 py-1 bg-[#F8BA34] text-black rounded"
        >
          Crop
        </button>
      </div>
    </div>
  </div>
)}
{showBibleCropper && (
  <div className="fixed inset-0 z-[999] bg-black/70 flex items-center justify-center">
    <div className="relative w-[400px] h-[400px] bg-[#1a1a1a] rounded-xl">
      <Cropper
        image={bibleImageSrc}
        crop={bibleCrop}
        zoom={bibleZoom}
        aspect={1}
        onCropChange={setBibleCrop}
        onZoomChange={setBibleZoom}
        onCropComplete={onBibleCropComplete}
      />

      <div className="absolute bottom-4 right-4 flex gap-3">
        <button
          onClick={() => setShowBibleCropper(false)}
          className="px-4 py-1 text-white border rounded"
        >
          Cancel
        </button>
        <button
          onClick={handleBibleCropSave}
          className="px-4 py-1 bg-[#F8BA34] text-black rounded"
        >
          Crop
        </button>
      </div>
    </div>
  </div>
)}
{showGalleryModal && (
  <div className="fixed inset-0 bg-black/70 z-[200] flex items-center justify-center">
    <div className="bg-[#111] rounded-xl p-6 w-[90%] max-w-[900px] relative">

      {/* Close */}
      <button
        className="absolute top-4 right-4"
        onClick={() => setShowGalleryModal(false)}
      >
        <AiOutlineClose className="text-white w-6 h-6" />
      </button>

      <h2 className="text-white text-lg mb-4">
        Select Image from Gallery
      </h2>

      {/* Gallery Grid */}
      <div className="flex flex-wrap gap-6 max-h-[60vh] overflow-y-auto">
        {galleryList?.map((item) => (
          <div
            key={item._id}
            className="cursor-pointer group"
            onClick={() => {
              setSelectedGalleryImage(item); // ✅ FULL OBJECT
              setShowGalleryModal(false);
            }}
          >
            <img
              src={item.imageUrl || item.url_link}
              alt={item.imageName}
              className="w-[180px] h-[120px] object-cover rounded-lg border border-gray-700 group-hover:border-[#F8BA34]"
            />

            <div className="text-xs text-gray-300 mt-1 text-center">
              {item.imageName}
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
)}

    </>
  );
};

export default CreateGroup;
